import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import { getDocs } from 'firebase/services/analysisLevelGuide';
import {fetchAnalysisLevelGuideSuccess, fetchAnalysisLevelGuideError} from '../actions/AnalysisLevelGuide';
import {FETCH_ANALYSIS_LEVEL_GUIDE} from 'constants/ActionTypes';


function* fetchAnalysisLevelGuideRequest() {
  try {
    const fetchedAnalysisLevelGuide = yield call(getDocs);
    yield put(fetchAnalysisLevelGuideSuccess(fetchedAnalysisLevelGuide));
  } catch (error) {
    console.log(error);
    yield put(fetchAnalysisLevelGuideError(error));
  }
}

export function* fetchAnalysisLevelGuide() {
  yield takeEvery(FETCH_ANALYSIS_LEVEL_GUIDE, fetchAnalysisLevelGuideRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchAnalysisLevelGuide)]);
}
